import React, { useEffect, useState } from "react";
import Header from "../home/header";
import UTILS from '../../utils/commons';
import { useLocation, useNavigate } from "react-router";
import { ApiClient } from "../../utils/api-client";
import { DateTime } from 'luxon'
import { Line, Bar } from "react-chartjs-2";
const Report = props => {
    const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState.accessToken )
    const formatCurrency = value => new Intl.NumberFormat( 'en-TZ', {
        style: 'currency',
        currency: 'TZS',
        maximumFractionDigits: 0,
    } ).format( Number( value || 0 ) );
    const formatDate = value => value ? DateTime.fromISO( new Date( value ).toISOString() ).toFormat( 'dd LLL yyyy' ) : 'No date';

    const [ activeTab, setActiveTab ] = useState( 'sales' )
    const [ reportPeriod, setReportPeriod ] = useState( 'Week' )
    const [ showHideDatePicker, setShowHideDatePicker ] = useState( false )
    const [ startDate, setStartDate ] = useState( DateTime.utc().startOf( 'week' ).toISODate() );
    const [ endDate, setEndDate ] = useState( DateTime.utc().endOf( 'week' ).toISODate() );
    const [ topSellingData, setTopSellingData ] = useState( null )
    const [ expensesSummary, setExpensesSummary ] = useState( null )
    const [ topExpenses, setTopExpenses ] = useState( [] )
    const [ debtsData, setDebtsData ] = useState( null )
    const [ chartData, setChartData ] = useState( null );
    const [ chartData2, setChartData2 ] = useState( null );
    const [ totalDiscountAllowed, setTotalDiscountAllowed ] = useState( 0 );
    // const [ filterBy, setFilterBy ] = useState( 'all' );
    const [ managers, setManagers ] = useState( [] );
    const [ selectedManager, setSelectedManager ] = useState( 'all' );
    // const [ products, setProducts ] = useState( [] );
    // const [ selectedProduct, setSelectedProduct ] = useState( 'all' );
    
    const chartLineOptions = {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
            line: {
                tension: 0.45,
                cubicInterpolationMode: 'monotone',
                borderWidth: 3,
            },
            point: {
                radius: 2,
                hoverRadius: 5,
            },
        },
        plugins: {
            legend: {
                display: true,
            }, title: {
                display: true,
                text: activeTab === 'sales' ? 'Sales Trend' : activeTab === 'expenses' ? 'Expenses Trend' : '',
                fontSize: 32,
            },
        },
    };

    const chartBarOptions = {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
            duration: 700,
            easing: 'easeOutQuart',
        },
        elements: {
            bar: {
                borderRadius: 4,
                borderWidth: 1,
            },
        },
        plugins: {
            legend: {
                display: true,
            },
            title: {
                display: true,
                text: activeTab === 'inventory' ? 'Inventory Report' : activeTab === 'debts' ? 'Debt Report' : activeTab === 'expenses' ? 'Expenses' : '',
                fontSize: 32,
            },

        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: true,
            },
        },
    };

    const buildReportQueryParams = ( startDate, endDate ) => {
        const queryParams = {
            startDate: DateTime.fromISO( startDate, { zone: 'utc' } ).startOf( 'day' ).toISO(),
            endDate: DateTime.fromISO( endDate, { zone: 'utc' } ).endOf( 'day' ).toISO(),
        };

        const financeOwnerId =
            loginState?.profile?.ownerId ||
            loginState?.manager?.ownerId ||
            loginState?.ownerScopeId;

        if ( loginState.role == UTILS.SALES ) queryParams.profileId = loginState.profile.id;
        if ( loginState.role == UTILS.ADMIN ) queryParams.ownerId = loginState.id;
        if ( loginState.role == UTILS.FINANCE && financeOwnerId ) queryParams.ownerId = financeOwnerId;

        return queryParams;
    };

    const getSalesTrend = async ( startDate, endDate, selectedManager ) => {
        const queryParams = buildReportQueryParams( startDate, endDate );
        if ( selectedManager && selectedManager !== 'all' ) {
            queryParams.profileId = selectedManager;
            queryParams.ownerId = loginState.id;
        }
        const [ salesReq, topSellersReq ] = await Promise.all( [
            apiClient.get( "/reports/sales-trend", { params: queryParams } ),
            apiClient.get( "/reports/top-sellers", { params: queryParams } )
        ] );
        setChartData2( null );
        setDebtsData( null );
        setExpensesSummary( null );
        setTopExpenses( [] );
        if ( topSellersReq.status === 200 && topSellersReq.data ) {
            setTopSellingData( topSellersReq.data );
        } else {
            setTopSellingData( null );
        }
        if ( salesReq.status === 200 && salesReq.data ) {
            setTotalDiscountAllowed( Number( salesReq.data.totalDiscountAllowed || 0 ) );
            setChartData( {
                labels: salesReq.data.labels,
                datasets: [
                    {
                        label: 'Total Sales',
                        data: salesReq.data.totalSales.map( d => d.amount ),
                        fill: false,
                        borderColor: 'rgba(75,192,192,1)',
                        tension: 0.45,
                        cubicInterpolationMode: 'monotone'
                    },
                    {
                        label: 'Cash Sales',
                        data: salesReq.data.cashSales.map( d => d.amount ),
                        fill: false,
                        borderColor: 'rgb(21, 107, 67)',
                        tension: 0.45,
                        cubicInterpolationMode: 'monotone'
                    },
                    {
                        label: 'Credit Sales',
                        data: salesReq.data.creditSales.map( d => d.amount ),
                        fill: false,
                        borderColor: 'rgb(192, 149, 75)',
                        tension: 0.45,
                        cubicInterpolationMode: 'monotone'
                    }
                ]
            } );
        } else {
            setChartData( null );
            setTotalDiscountAllowed( 0 );
        }
    }
    const getReports = async ( startDate, endDate ) => {
        switch ( activeTab ) {
            case 'sales':
                getSalesTrend( startDate, endDate );
                break;
            case 'inventory':
                getInventoryReport( startDate, endDate );
                break;
            case 'expenses':
                getExpensesTrend( startDate, endDate );
                break;
            case 'debts':
                getDebtsReport( startDate, endDate );
                break;
        }
        if ( managers.length === 0 ) getManagers();
    }

    const getInventoryReport = async ( startDate, endDate ) => {
        const queryParams = buildReportQueryParams( startDate, endDate );
        const endpoint = ( loginState.role == UTILS.ADMIN || loginState.role == UTILS.FINANCE )
            ? "/reports/inventory"
            : "/reports/inventory/profile";
        const req = await apiClient.get( endpoint, { params: queryParams } );
        setTopSellingData( null );
        setDebtsData( null );
        setExpensesSummary( null );
        setTopExpenses( [] );
        if ( req.status === 200 && req.data ) {
            setChartData( {
                labels: req.data.inventoryReport.map( d => d.productName ),
                datasets: [
                    {
                        label: 'Sold Inventory',
                        data: req.data.inventoryReport.map( d => d.totalSold ),
                        fill: true,
                        backgroundColor: 'rgba(75,192,192,1)',
                        borderColor: 'rgba(75,192,192,1)',
                        tension: 0.45,
                        cubicInterpolationMode: 'monotone'
                    },
                    {
                        label: 'Available Inventory',
                        data: req.data.inventoryReport.map( d => d.totalPurchasedQuantity - d.totalSold ),
                        fill: true,
                        backgroundColor: 'rgb(240, 172, 88)',
                        borderColor: 'rgb(240, 172, 88)',
                        tension: 0.45,
                        cubicInterpolationMode: 'monotone'
                    },
                ]
            } );

            if ( ( loginState.role == UTILS.ADMIN || loginState.role == UTILS.FINANCE ) && req.data.staffInventoryByProduct ) {
                const staffInventory = req.data.staffInventoryByProduct;
                const staffLabels = staffInventory.map( member => member.staffName );
                const productNameSet = new Set();

                staffInventory.forEach( member => {
                    ( member.products || [] ).forEach( product => {
                        productNameSet.add( product.productName );
                    } );
                } );

                const productNames = Array.from( productNameSet );
                const colorPalette = [
                    'rgba(30, 136, 229, 0.75)',
                    'rgba(67, 160, 71, 0.75)',
                    'rgba(251, 140, 0, 0.75)',
                    'rgba(142, 36, 170, 0.75)',
                    'rgba(0, 137, 123, 0.75)',
                    'rgba(229, 57, 53, 0.75)',
                    'rgba(84, 110, 122, 0.75)',
                ];

                const groupedDatasets = productNames.map( ( productName, index ) => {
                    const color = colorPalette[ index % colorPalette.length ];
                    return {
                        label: productName,
                        data: staffInventory.map( member => {
                            const found = ( member.products || [] ).find( p => p.productName === productName );
                            return found ? Number( found.remainingQuantity ) : 0;
                        } ),
                        backgroundColor: color,
                        borderColor: color,
                        borderWidth: 1,
                    };
                } );

                setChartData2( {
                    labels: staffLabels,
                    datasets: groupedDatasets,
                } );
            } else {
                setChartData2( null );
            }

        }
    }

    const getExpensesTrend = async ( startDate, endDate ) => {
        const queryParams = buildReportQueryParams( startDate, endDate );

        const req = await apiClient.get( "/reports/expenses-trend", { params: queryParams } );
        setTopSellingData( null );
        setChartData2( null );
        setDebtsData( null );

        if ( req.status === 200 && req.data ) {
            setExpensesSummary( req.data.summary || null );
            setTopExpenses( req.data.topExpenses || [] );
            setChartData( {
                labels: req.data.labels,
                datasets: [
                    {
                        label: 'Total Expenses',
                        data: req.data.totalExpenses.map( d => d.amount ),
                        fill: false,
                        borderColor: 'rgb(220, 38, 38)',
                        backgroundColor: 'rgba(220, 38, 38, 0.15)',
                        tension: 0.45,
                        cubicInterpolationMode: 'monotone'
                    }
                ]
            } );
        } else {
            setExpensesSummary( null );
            setTopExpenses( [] );
            setChartData( null );
        }
    }

    const getDebtsReport = async ( startDate, endDate ) => {
        const queryParams = buildReportQueryParams( startDate, endDate );

        const req = await apiClient.get( "/reports/debts", { params: queryParams } );
        setTopSellingData( null );
        setExpensesSummary( null );
        setTopExpenses( [] );
        setChartData2( null );

        if ( req.status === 200 && req.data ) {
            setDebtsData( req.data );
            setChartData( {
                labels: ( req.data.topDebtors || [] ).map( item => item.customerName ),
                datasets: [
                    {
                        label: 'Outstanding Debt',
                        data: ( req.data.topDebtors || [] ).map( item => Number( item.outstandingDebt || 0 ) ),
                        backgroundColor: 'rgba(239, 68, 68, 0.75)',
                        borderColor: 'rgba(220, 38, 38, 1)',
                        borderWidth: 1,
                        maxBarThickness: 38,
                        categoryPercentage: 0.55,
                        barPercentage: 0.7,
                    }
                ]
            } );
        } else {
            setDebtsData( null );
            setChartData( null );
        }
    }

    const getManagers = async () => {
        const req = await apiClient.get( "/profiles/list" );
        if ( req.status === 200 && req.data ) {
            setManagers( req.data );
        }

    }
    // const getProducts = async () => {
    //     const req = await apiClient.get( "/products/list" );
    //     if ( req.status === 200 && req.data ) {
    //         setProducts( req.data );
    //     }

    // }

    const renderRankedList = ( title, items, renderMeta, emptyText ) => {
        return <div className="border rounded-md p-4 shadow-sm bg-white">
            <div className="flex items-center justify-between mb-4">
                <p className="text-lg font-semibold text-gray-800">{title}</p>
                <span className="text-sm text-gray-500">Top {items.length}</span>
            </div>
            {items.length ? <div className="flex flex-col gap-3">
                {items.map( ( item, index ) => {
                    return <div key={item.productId || item.profileId || `${title}-${index}`} className="border border-gray-100 rounded-md px-3 py-4 bg-gray-50">
                        <div className="flex items-start justify-between gap-3">
                            <div>
                                <p className="text-xs uppercase tracking-wide text-secondary-500 font-semibold">#{index + 1}</p>
                                <p className="text-sm lg:text-base font-semibold text-gray-800">{item.productName || item.staffName}</p>
                            </div>
                            <div className="text-right text-xs lg:text-sm text-gray-500">
                                {renderMeta( item )}
                            </div>
                        </div>
                    </div>
                } )}
            </div> : <div className="border border-dashed rounded-md px-3 py-6 text-sm text-gray-500 text-center bg-gray-50">{emptyText}</div>}
        </div>
    }

    const escapeCsvValue = ( value ) => {
        const normalized = value === null || value === undefined ? '' : String( value );
        return `"${normalized.replace( /"/g, '""' )}"`;
    };

    const exportTableToCsv = ( filename, columns, rows ) => {
        const header = columns.map( column => escapeCsvValue( column.label ) ).join( ',' );
        const body = rows.map( row => columns.map( column => escapeCsvValue( column.getValue( row ) ) ).join( ',' ) );
        const csvContent = [ header, ...body ].join( '\n' );

        const blob = new Blob( [ csvContent ], { type: 'text/csv;charset=utf-8;' } );
        const url = URL.createObjectURL( blob );
        const link = document.createElement( 'a' );
        link.href = url;
        link.setAttribute( 'download', filename );
        document.body.appendChild( link );
        link.click();
        document.body.removeChild( link );
        URL.revokeObjectURL( url );
    };

    const handleReportPeriodChange = ( e, rp ) => {
        setReportPeriod( rp );
        if ( rp === 'Custom' ) {
            setShowHideDatePicker( true );
        } else {
            let startDate, endDate;
            const today = new Date();
            switch ( rp ) {
                case "Week":
                    startDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).startOf( 'week' ).toJSDate();
                    endDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).endOf( 'week' ).toJSDate();
                    break;
                case "Month":
                    startDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).startOf( 'month' ).toJSDate();
                    endDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).endOf( 'month' ).toJSDate();
                    break;
                case "Year":
                    startDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).startOf( 'year' ).toJSDate();
                    endDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).endOf( 'year' ).toJSDate();
                    break;
            }
            const normalizedStartDate = DateTime.fromJSDate( startDate, { zone: 'utc' } ).toISODate();
            const normalizedEndDate = DateTime.fromJSDate( endDate, { zone: 'utc' } ).toISODate();

            setStartDate( normalizedStartDate );
            setEndDate( normalizedEndDate );
            getReports( normalizedStartDate, normalizedEndDate );
        }
    };

    const handleCustomDateApply = () => {
        if ( startDate && endDate ) {
            setShowHideDatePicker( false );
            getReports( startDate, endDate );
        }
    };

    const handleCustomDateChange = ( e ) => {
        const id = e.target.id;
        const date = e.target.value.trim();
        if ( id == 'startDate' ) setStartDate( DateTime.fromISO( date, { zone: 'utc' } ).toISODate() );
        if ( id == 'endDate' ) setEndDate( DateTime.fromISO( date, { zone: 'utc' } ).toISODate() )
    }

    useEffect( () => {
        getReports( startDate, endDate );
    }, [ activeTab ] )

    const tabs = [
        { label: 'Sales', value: 'sales' },
        { label: 'Inventory', value: 'inventory' },
        { label: 'Expenses', value: 'expenses' },
        { label: 'Debts', value: 'debts' }
    ]
    return (
        <>
            <Header auth={loginState} />
            <section className="w-full px-4 lg:w-[98%]  md:flex md:justify-between items-center mx-auto rounded-md">
                <div className="justify-between w-full flex md:justify-start items-center md:w-8/12 mx-auto">
                    {tabs.map( ( tab => {
                        return <div key={tab.value} onClick={() => { setActiveTab( tab.value ) }} className={`cursor-pointer w-full md:w-4/12 border rounded-t-lg  px-2 py-1 ${activeTab == tab.value ? 'bg-secondary-500 text-white' : ''} `}>
                            {tab.label}
                        </div>

                    } ) )}

                </div>

                {/* <div className="w-full md:w-4/12 flex flex-col justify-center items-center p-4" id="summary-area"> */}
                <div className="w-full flex justify-center md:justify-end px-4 space-x-4">
                    {[ "Week", "Month", "Year", "Custom" ].map( ( rp ) => {
                        return <span onClick={( e ) => { handleReportPeriodChange( e, rp ) }} key={rp} className={`btn px-2 py-1 ${reportPeriod === rp ? 'bg-primary-300' : 'bg-secondary-300'} rounded-lg shadow hover:bg-secondary-500 hover:text-white text-sm lg:text-xl`}>{rp}</span>
                    } )}

                </div>
                {/* </div> */}
                {showHideDatePicker && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                        <div className="bg-white rounded-lg shadow-lg p-8 min-w-[320px] flex flex-col gap-4 relative">
                            <button className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl" onClick={() => setShowHideDatePicker( false )}>&times;</button>
                            <h2 className="text-lg font-bold mb-2">Select Custom Date Range</h2>
                            <div className="flex flex-col gap-2">
                                <label htmlFor="customStartDate" className="font-medium">Start Date</label>
                                <input
                                    type="date"
                                    id="startDate"
                                    className="form-control"
                                    value={startDate}
                                    onChange={( e ) => { handleCustomDateChange( e ) }}
                                    max={endDate || undefined}
                                />
                            </div>
                            <div className="flex flex-col gap-2">
                                <label htmlFor="customEndDate" className="font-medium">End Date</label>
                                <input
                                    type="date"
                                    id="endDate"
                                    className="form-control"
                                    value={endDate}
                                    onChange={( e ) => { handleCustomDateChange( e ) }}
                                    min={startDate || undefined}
                                />
                            </div>
                            <div className="flex gap-4 mt-4">
                                <button
                                    className="bg-primary-500 text-white px-4 py-2 rounded disabled:opacity-50"
                                    disabled={!startDate || !endDate}
                                    onClick={handleCustomDateApply}
                                    type="button"
                                >Apply</button>
                                <button
                                    className="bg-gray-300 px-4 py-2 rounded"
                                    onClick={() => setShowHideDatePicker( false )}
                                    type="button"
                                >Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
            </section>
            <section className="pt-8">
                {loginState.role == UTILS.ADMIN || loginState.role == UTILS.ADMIN ?
                    <div className="flex justify-end items-center mx-8 gap-4">
                        
                            <div className="flex flex-col">
                                <label>Select Manager:</label>
                                <select className="mb-4 px-3 py-2 border rounded" onChange={( e ) => { setSelectedManager( e.target.value ); getSalesTrend(startDate, endDate, e.target.value) }} value={selectedManager}>
                                    <option value="all">All Managers</option>
                                    {managers.map( manager => {
                                        const firstName = manager.firstName || manager.auth?.firstName || '';
                                        const lastName = manager.lastName || manager.auth?.lastName || '';
                                        return <option key={manager.id} value={manager.id}>{`${firstName} ${lastName}`.trim()}</option>;
                                    } )}
                                </select>
                            </div> 
                    </div> : null}
                <p className="text-2xl mb-4 mx-8">{activeTab.charAt( 0 ).toUpperCase() + activeTab.slice( 1 )} Report</p>
                <div className="w-full px-4 lg:w-[98%] mx-auto mt-8 pb-16 pt-4 shadow rounded-md grid lg:grid-cols-2 gap-2">
                    {activeTab == 'inventory' && chartData ?
                        <div className="w-full h-[28rem] p-4 border rounded-md">
                            <p className="text-lg mb-2">Product Availability</p>
                            <Bar data={chartData} options={chartBarOptions} />
                        </div> :
                        <div className="w-full h-96 flex flex-col justify-center items-center p-4 border" id="summary-area">
                            {activeTab == 'sales' && chartData ? <Line data={chartData} options={chartLineOptions} /> : null}
                            {activeTab == 'expenses' && chartData ? <Line data={chartData} options={chartLineOptions} /> : null}
                            {activeTab == 'debts' && chartData ? <Bar data={chartData} options={chartBarOptions} /> : null}

                        </div>}
                    {activeTab == 'sales' ? <div className="flex flex-col gap-4">
                        <div className="border rounded-md p-4 shadow-sm bg-white">
                            <p className="text-xs uppercase tracking-wide text-secondary-500 font-semibold">Discounts Allowed</p>
                            <p className="text-xl font-semibold text-gray-800 mt-1">{formatCurrency( totalDiscountAllowed )}</p>
                            <p className="text-sm text-gray-500">Total discount granted during the selected period.</p>
                        </div>
                        {renderRankedList(
                            'Top Products',
                            topSellingData?.topProducts || [],
                            item => <>
                                <p>{Number( item.totalSold || 0 )} units sold</p>
                                <p>{formatCurrency( item.totalRevenue )} revenue</p>
                            </>,
                            'No product sales found for the selected period.'
                        )}
                        {renderRankedList(
                            'Top Staff',
                            topSellingData?.topStaff || [],
                            item => <>
                                <p>{formatCurrency( item.totalRevenue )} revenue</p>
                                <p>{Number( item.totalTransactions || 0 )} transactions</p>
                            </>,
                            'No staff sales found for the selected period.'
                        )}
                    </div> : null}
                    {activeTab == 'sales' ? <div className="lg:col-span-2 border rounded-md p-4 shadow-sm bg-white overflow-x-auto">
                        <div className="flex items-center justify-between mb-4">
                            <p className="text-lg font-semibold text-gray-800">Sales Staff Performance</p>
                            <div className="flex items-center gap-3">
                                <span className="text-sm text-gray-500">{( topSellingData?.allStaffSales || [] ).length} staff</span>
                                <button
                                    type="button"
                                    className="text-xs px-3 py-1 rounded border border-gray-300 hover:bg-gray-100"
                                    onClick={() => exportTableToCsv(
                                        `sales-staff-performance-${startDate}-to-${endDate}.csv`,
                                        [
                                            { label: 'Rank', getValue: ( item ) => ( topSellingData?.allStaffSales || [] ).findIndex( i => i.profileId === item.profileId ) + 1 },
                                            { label: 'Staff', getValue: ( item ) => item.staffName || 'Unassigned' },
                                            { label: 'Transactions', getValue: ( item ) => Number( item.totalTransactions || 0 ) },
                                            { label: 'Total Sales', getValue: ( item ) => Number( item.totalRevenue || 0 ) },
                                        ],
                                        topSellingData?.allStaffSales || []
                                    )}
                                    disabled={!( topSellingData?.allStaffSales || [] ).length}
                                >
                                    Export CSV
                                </button>
                            </div>
                        </div>
                        {( topSellingData?.allStaffSales || [] ).length ? <table className="w-full text-left min-w-[48rem]">
                            <thead>
                                <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500">
                                    <th className="py-3 pr-4 font-semibold">Rank</th>
                                    <th className="py-3 pr-4 font-semibold">Staff</th>
                                    <th className="py-3 pr-4 font-semibold text-right">Transactions</th>
                                    <th className="py-3 font-semibold text-right">Total Sales</th>
                                </tr>
                            </thead>
                            <tbody>
                                {( topSellingData?.allStaffSales || [] ).map( ( item, index ) => <tr key={item.profileId || `${item.staffName}-${index}`} className="border-b border-gray-100 last:border-b-0 text-sm text-gray-700">
                                    <td className="py-3 pr-4 font-semibold text-secondary-500">#{index + 1}</td>
                                    <td className="py-3 pr-4 text-gray-800 font-medium">{item.staffName || 'Unassigned'}</td>
                                    <td className="py-3 pr-4 text-right">{Number( item.totalTransactions || 0 )}</td>
                                    <td className="py-3 text-right font-semibold text-gray-800">{formatCurrency( item.totalRevenue )}</td>
                                </tr> )}
                            </tbody>
                        </table> : <div className="border border-dashed rounded-md px-3 py-6 text-sm text-gray-500 text-center bg-gray-50">No sales staff activity found for the selected period.</div>}
                    </div> : null}
                    {activeTab == 'expenses' ? <div className="flex flex-col gap-4">
                        <div className="border rounded-md p-4 shadow-sm bg-white">
                            <p className="text-lg font-semibold text-gray-800 mb-4">Expense Summary</p>
                            <div className="grid gap-3">
                                <div className="border border-gray-100 rounded-md px-3 py-4 bg-gray-50">
                                    <p className="text-xs uppercase tracking-wide text-secondary-500 font-semibold">Total Expenses</p>
                                    <p className="text-lg font-semibold text-gray-800 mt-1">{formatCurrency( expensesSummary?.totalExpenses )}</p>
                                </div>
                                <div className="border border-gray-100 rounded-md px-3 py-4 bg-gray-50">
                                    <p className="text-xs uppercase tracking-wide text-secondary-500 font-semibold">Expense Entries</p>
                                    <p className="text-lg font-semibold text-gray-800 mt-1">{Number( expensesSummary?.expenseCount || 0 )}</p>
                                </div>
                                <div className="border border-gray-100 rounded-md px-3 py-4 bg-gray-50">
                                    <p className="text-xs uppercase tracking-wide text-secondary-500 font-semibold">Average Expense</p>
                                    <p className="text-lg font-semibold text-gray-800 mt-1">{formatCurrency( expensesSummary?.averageExpense )}</p>
                                </div>
                            </div>
                        </div>
                    </div> : null}
                    {activeTab == 'debts' ? <div className="flex flex-col gap-4">
                        <div className="border rounded-md p-4 shadow-sm bg-white">
                            <p className="text-lg font-semibold text-gray-800 mb-4">Debt Summary</p>
                            <div className="grid gap-3">
                                <div className="border border-gray-100 rounded-md px-3 py-4 bg-gray-50">
                                    <p className="text-xs uppercase tracking-wide text-secondary-500 font-semibold">Total Debts</p>
                                    <p className="text-lg font-semibold text-gray-800 mt-1">{formatCurrency( debtsData?.summary?.totalDebts )}</p>
                                </div>
                                <div className="border border-gray-100 rounded-md px-3 py-4 bg-gray-50">
                                    <p className="text-xs uppercase tracking-wide text-secondary-500 font-semibold">Customers with Debt</p>
                                    <p className="text-lg font-semibold text-gray-800 mt-1">{Number( debtsData?.summary?.totalCustomersWithDebt || 0 )}</p>
                                </div>
                                <div className="border border-gray-100 rounded-md px-3 py-4 bg-gray-50">
                                    <p className="text-xs uppercase tracking-wide text-secondary-500 font-semibold">Staff with Uncollected Debt</p>
                                    <p className="text-lg font-semibold text-gray-800 mt-1">{Number( debtsData?.summary?.totalStaffWithDebt || 0 )}</p>
                                </div>
                            </div>
                        </div>
                    </div> : null}
                    {activeTab == 'expenses' ? <div className="lg:col-span-2 border rounded-md p-4 shadow-sm bg-white overflow-x-auto">
                        <div className="flex items-center justify-between mb-4">
                            <p className="text-lg font-semibold text-gray-800">Top Expenses</p>
                            <div className="flex items-center gap-3">
                                <span className="text-sm text-gray-500">Top {topExpenses.length}</span>
                                <button
                                    type="button"
                                    className="text-xs px-3 py-1 rounded border border-gray-300 hover:bg-gray-100"
                                    onClick={() => exportTableToCsv(
                                        `top-expenses-${startDate}-to-${endDate}.csv`,
                                        [
                                            { label: 'Rank', getValue: ( item ) => topExpenses.findIndex( i => i.paymentId === item.paymentId ) + 1 },
                                            { label: 'Staff', getValue: ( item ) => item.staffName || 'Unassigned' },
                                            { label: 'Paid To', getValue: ( item ) => item.paidTo || '' },
                                            { label: 'Reason', getValue: ( item ) => item.reason || '' },
                                            { label: 'Date', getValue: ( item ) => formatDate( item.paymentDate ) },
                                            { label: 'Amount', getValue: ( item ) => Number( item.amount || 0 ) },
                                        ],
                                        topExpenses
                                    )}
                                    disabled={!topExpenses.length}
                                >
                                    Export CSV
                                </button>
                            </div>
                        </div>
                        {topExpenses.length ? <table className="w-full text-left min-w-[52rem]">
                            <thead>
                                <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500">
                                    <th className="py-3 pr-4 font-semibold">Rank</th>
                                    <th className="py-3 pr-4 font-semibold">Staff</th>
                                    <th className="py-3 pr-4 font-semibold">Paid To</th>
                                    <th className="py-3 pr-4 font-semibold">Reason</th>
                                    <th className="py-3 pr-4 font-semibold">Date</th>
                                    <th className="py-3 font-semibold text-right">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {topExpenses.map( ( expense, index ) => <tr key={expense.paymentId} className="border-b border-gray-100 last:border-b-0 text-sm text-gray-700">
                                    <td className="py-3 pr-4 font-semibold text-secondary-500">#{index + 1}</td>
                                    <td className="py-3 pr-4 text-gray-600">{expense.staffName || 'Unassigned'}</td>
                                    <td className="py-3 pr-4 font-medium text-gray-800">{expense.paidTo}</td>
                                    <td className="py-3 pr-4 text-gray-600">{expense.reason}</td>
                                    <td className="py-3 pr-4 text-gray-600">{formatDate( expense.paymentDate )}</td>
                                    <td className="py-3 text-right font-semibold text-gray-800">{formatCurrency( expense.amount )}</td>
                                </tr> )}
                            </tbody>
                        </table> : <div className="border border-dashed rounded-md px-3 py-6 text-sm text-gray-500 text-center bg-gray-50">No expenses found for the selected period.</div>}
                    </div> : null}
                    {activeTab == 'debts' ? <div className="lg:col-span-2 border rounded-md p-4 shadow-sm bg-white overflow-x-auto">
                        <div className="flex items-center justify-between mb-4">
                            <p className="text-lg font-semibold text-gray-800">Customer Outstanding Debts</p>
                            <div className="flex items-center gap-3">
                                <span className="text-sm text-gray-500">{( debtsData?.customerDebts || [] ).length} customers</span>
                                <button
                                    type="button"
                                    className="text-xs px-3 py-1 rounded border border-gray-300 hover:bg-gray-100"
                                    onClick={() => exportTableToCsv(
                                        `customer-outstanding-debts-${startDate}-to-${endDate}.csv`,
                                        [
                                            { label: 'Customer', getValue: ( item ) => item.customerName || '' },
                                            { label: 'Staff', getValue: ( item ) => item.staffName || 'Unassigned' },
                                            { label: 'Credit Sales', getValue: ( item ) => Number( item.totalCredit || 0 ) },
                                            { label: 'Collected', getValue: ( item ) => Number( item.totalCollected || 0 ) },
                                            { label: 'Outstanding Debt', getValue: ( item ) => Number( item.outstandingDebt || 0 ) },
                                        ],
                                        debtsData?.customerDebts || []
                                    )}
                                    disabled={!( debtsData?.customerDebts || [] ).length}
                                >
                                    Export CSV
                                </button>
                            </div>
                        </div>
                        {( debtsData?.customerDebts || [] ).length ? <table className="w-full text-left min-w-[58rem]">
                            <thead>
                                <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500">
                                    <th className="py-3 pr-4 font-semibold">Customer</th>
                                    <th className="py-3 pr-4 font-semibold">Staff</th>
                                    <th className="py-3 pr-4 font-semibold text-right">Credit Sales</th>
                                    <th className="py-3 pr-4 font-semibold text-right">Collected</th>
                                    <th className="py-3 font-semibold text-right">Outstanding Debt</th>
                                </tr>
                            </thead>
                            <tbody>
                                {( debtsData?.customerDebts || [] ).map( item => <tr key={item.customerId} className="border-b border-gray-100 last:border-b-0 text-sm text-gray-700">
                                    <td className="py-3 pr-4 text-gray-800 font-medium">{item.customerName}</td>
                                    <td className="py-3 pr-4 text-gray-600">{item.staffName || 'Unassigned'}</td>
                                    <td className="py-3 pr-4 text-right">{formatCurrency( item.totalCredit )}</td>
                                    <td className="py-3 pr-4 text-right">{formatCurrency( item.totalCollected )}</td>
                                    <td className="py-3 text-right font-semibold text-red-600">{formatCurrency( item.outstandingDebt )}</td>
                                </tr> )}
                            </tbody>
                        </table> : <div className="border border-dashed rounded-md px-3 py-6 text-sm text-gray-500 text-center bg-gray-50">No customer debt found for the selected period.</div>}
                    </div> : null}
                    {activeTab == 'debts' ? <>
                        <div className="border rounded-md p-4 shadow-sm bg-white overflow-x-auto">
                            <div className="flex items-center justify-between mb-4">
                                <p className="text-lg font-semibold text-gray-800">Uncollected Debts</p>
                                <div className="flex items-center gap-3">
                                    <span className="text-sm text-gray-500">{( debtsData?.staffDebts || [] ).length} staff</span>
                                    <button
                                        type="button"
                                        className="text-xs px-3 py-1 rounded border border-gray-300 hover:bg-gray-100"
                                        onClick={() => exportTableToCsv(
                                            `uncollected-debts-${startDate}-to-${endDate}.csv`,
                                            [
                                                { label: 'Staff', getValue: ( item ) => item.staffName || 'Unassigned' },
                                                { label: 'Credit Sales', getValue: ( item ) => Number( item.totalCredit || 0 ) },
                                                { label: 'Collected', getValue: ( item ) => Number( item.totalCollected || 0 ) },
                                                { label: 'Uncollected', getValue: ( item ) => Number( item.uncollectedDebt || 0 ) },
                                            ],
                                            debtsData?.staffDebts || []
                                        )}
                                        disabled={!( debtsData?.staffDebts || [] ).length}
                                    >
                                        Export CSV
                                    </button>
                                </div>
                            </div>
                            {( debtsData?.staffDebts || [] ).length ? <table className="w-full text-left">
                                <thead>
                                    <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500">
                                        <th className="py-3 pr-4 font-semibold">Staff</th>
                                        <th className="py-3 pr-4 font-semibold text-right">Credit Sales</th>
                                        <th className="py-3 pr-4 font-semibold text-right">Collected</th>
                                        <th className="py-3 font-semibold text-right">Uncollected</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {( debtsData?.staffDebts || [] ).map( item => <tr key={item.profileId} className="border-b border-gray-100 last:border-b-0 text-sm text-gray-700">
                                        <td className="py-3 pr-4 text-gray-800 font-medium">{item.staffName}</td>
                                        <td className="py-3 pr-4 text-right">{formatCurrency( item.totalCredit )}</td>
                                        <td className="py-3 pr-4 text-right">{formatCurrency( item.totalCollected )}</td>
                                        <td className="py-3 text-right font-semibold text-red-600">{formatCurrency( item.uncollectedDebt )}</td>
                                    </tr> )}
                                </tbody>
                            </table> : <div className="border border-dashed rounded-md px-3 py-6 text-sm text-gray-500 text-center bg-gray-50">No uncollected staff debt found for the selected period.</div>}
                        </div>
                        <div className="border rounded-md p-4 shadow-sm bg-white overflow-x-auto">
                            <div className="flex items-center justify-between mb-4">
                                <p className="text-lg font-semibold text-gray-800">Top 5 Debtors</p>
                                <div className="flex items-center gap-3">
                                    <span className="text-sm text-gray-500">Top {( debtsData?.topDebtors || [] ).length}</span>
                                    <button
                                        type="button"
                                        className="text-xs px-3 py-1 rounded border border-gray-300 hover:bg-gray-100"
                                        onClick={() => exportTableToCsv(
                                            `top-debtors-${startDate}-to-${endDate}.csv`,
                                            [
                                                { label: 'Rank', getValue: ( item ) => ( debtsData?.topDebtors || [] ).findIndex( i => i.customerId === item.customerId ) + 1 },
                                                { label: 'Customer', getValue: ( item ) => item.customerName || '' },
                                                { label: 'Staff', getValue: ( item ) => item.staffName || 'Unassigned' },
                                                { label: 'Outstanding Debt', getValue: ( item ) => Number( item.outstandingDebt || 0 ) },
                                            ],
                                            debtsData?.topDebtors || []
                                        )}
                                        disabled={!( debtsData?.topDebtors || [] ).length}
                                    >
                                        Export CSV
                                    </button>
                                </div>
                            </div>
                            {( debtsData?.topDebtors || [] ).length ? <table className="w-full text-left">
                                <thead>
                                    <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500">
                                        <th className="py-3 pr-4 font-semibold">Rank</th>
                                        <th className="py-3 pr-4 font-semibold">Customer</th>
                                        <th className="py-3 pr-4 font-semibold">Staff</th>
                                        <th className="py-3 font-semibold text-right">Outstanding Debt</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {( debtsData?.topDebtors || [] ).map( ( item, index ) => <tr key={item.customerId} className="border-b border-gray-100 last:border-b-0 text-sm text-gray-700">
                                        <td className="py-3 pr-4 font-semibold text-secondary-500">#{index + 1}</td>
                                        <td className="py-3 pr-4 text-gray-800 font-medium">{item.customerName}</td>
                                        <td className="py-3 pr-4 text-gray-600">{item.staffName || 'Unassigned'}</td>
                                        <td className="py-3 text-right font-semibold text-red-600">{formatCurrency( item.outstandingDebt )}</td>
                                    </tr> )}
                                </tbody>
                            </table> : <div className="border border-dashed rounded-md px-3 py-6 text-sm text-gray-500 text-center bg-gray-50">No top debtors found for the selected period.</div>}
                        </div>
                    </> : null}
                    {activeTab == 'inventory' && chartData2 ? (
                        <div className="w-full h-[28rem] p-4 border rounded-md">
                            <p className="text-lg mb-2">Staff Product Availability</p>
                            <Bar data={chartData2} options={chartBarOptions} />
                        </div>
                    ) : null}
                </div>
            </section>
        </> )

}
export default Report;
